import { useComposerPostTitleEnabled } from '~publish/hooks/useComposerPostTitleEnabled'

import { useComposerMode } from '../store/appSlice/hooks'
import { useOmniDraftId } from '../store/postSlice/hooks'

import { useIsChannelLessDraftMode } from './useIsChannelLessDraftMode'

/**
 * True when this composer session has, or will get on save, a ContentItem to
 * title: a channel-less draft, a channel-specific post already in a group, or
 * any not-yet-saved post (saving always creates a group). False only when
 * editing an existing post with no known group to title.
 */
export function useHasContentItemTitle(): boolean {
  const isChannelLessDraftMode = useIsChannelLessDraftMode()
  const contentItemId = useOmniDraftId()
  const mode = useComposerMode()
  const isPostTitleEnabled = useComposerPostTitleEnabled()

  if (!isPostTitleEnabled) return false
  return isChannelLessDraftMode || !!contentItemId || mode !== 'edit'
}
